import React from "react";
import { WebPlayer } from "../WebPlayer";

export const IframeScreen = (props: { singleGameSite: boolean }) => {
	log.info("Render IframeScreen...");

	return (
		<div id="iframe-container">
			<WebPlayer disableInstallation disableStoreLink singleGameSite />
		</div>
	);
};
